export enum PlanType {
  ONGOING = "ONGOING",
  ONE_OFF = "ONE_OFF",
}
